import { render, staticRenderFns } from "./LayoutRenderer.vue?vue&type=template&id=4d10e6a4"
import script from "./LayoutRenderer.vue?vue&type=script&lang=js"
export * from "./LayoutRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports